function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "user_inline_svg__Icon_feather-users",
  "data-name": "Icon feather-users",
  transform: "translate(-.85 -3.85)",
  fill: "#fdf7ec"
}, /*#__PURE__*/React.createElement("path", {
  id: "user_inline_svg__Path_215",
  "data-name": "Path 215",
  d: "M11.889 27.046a.65.65 0 01-.65-.65V25.1a1.95 1.95 0 00-1.947-1.95H4.1a1.947 1.947 0 00-1.95 1.95v1.3a.65.65 0 01-1.3 0v-1.3a3.247 3.247 0 013.25-3.25h5.192a3.251 3.251 0 013.247 3.25v1.3a.65.65 0 01-.65.646z",
  transform: "translate(0 -10.208)"
}), /*#__PURE__*/React.createElement("path", {
  id: "user_inline_svg__Path_216",
  "data-name": "Path 216",
  d: "M10.1 3.85A3.247 3.247 0 116.85 7.1a3.251 3.251 0 013.25-3.25zm0 5.195A1.947 1.947 0 108.15 7.1a1.95 1.95 0 001.95 1.945z",
  transform: "translate(-3.403)"
}), /*#__PURE__*/React.createElement("path", {
  id: "user_inline_svg__Path_217",
  "data-name": "Path 217",
  d: "M31.948 27.157a.65.65 0 01-.65-.65v-1.3a1.947 1.947 0 00-1.46-1.884.65.65 0 01.325-1.259 3.247 3.247 0 012.437 3.143v1.3a.65.65 0 01-.652.65z",
  transform: "translate(-16.163 -10.319)"
}), /*#__PURE__*/React.createElement("path", {
  id: "user_inline_svg__Path_218",
  "data-name": "Path 218",
  d: "M24 10.377a.65.65 0 01-.161-1.28 1.947 1.947 0 000-3.773.65.65 0 11.322-1.259 3.247 3.247 0 010 6.292.651.651 0 01-.161.02z",
  transform: "translate(-12.76 -.111)"
}));

function SvgUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.585,
    height: 12.988,
    viewBox: "0 0 15.585 12.988"
  }, props), _ref);
}

export default SvgUserinline;